import api from './api';

const eventService = {
  // Public event endpoints
  getEvents: (params) => api.get('/events', { params }),
  getEvent: (id) => api.get(`/events/${id}`),
  getFeaturedEvents: () => api.get('/events/featured'),
  getTopEvents: () => api.get('/events/top'),
  getCategories: () => api.get('/events/categories'),
  
  // Favorites
  getFavorites: () => api.get('/favorites'),
  addFavorite: (eventId) => api.post(`/favorites/${eventId}`),
  removeFavorite: (eventId) => api.delete(`/favorites/${eventId}`),
};

export default eventService;

